module.exports = __webpack_public_path__ + "media/images/athletes/1846-3155f0e68cb2fac9c9222e92bfa1b9e9.png";